import type {ReactNode} from 'react'
import {useDisclosure} from './use-disclosure'
import {DisclosureContext} from './disclosure-context'
import {DisclosureTrigger} from './DisclosureTrigger'
import {DisclosureChevron} from './DisclosureChevron'
import {DisclosurePanel} from './DisclosurePanel'

export interface DisclosureRootProps {
  defaultOpen?: boolean
  open?: boolean
  onOpenChange?: (open: boolean) => void
  children: ReactNode
}

const DisclosureRoot = ({defaultOpen, open, onOpenChange, children}: DisclosureRootProps) => {
  const disclosure = useDisclosure({defaultOpen, open, onOpenChange})
  return <DisclosureContext value={disclosure}>{children}</DisclosureContext>
}

export const Disclosure = Object.assign(DisclosureRoot, {
  Trigger: DisclosureTrigger,
  Panel: DisclosurePanel,
  Chevron: DisclosureChevron,
})

export default Disclosure
